import getLocalString from "constants/Localization";
import { useDeleteProposalRecipientMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import React from "react";

export default function useDeleteProposalRecipient() {
  const [mutation, { loading, data, error }] = useDeleteProposalRecipientMutation();

  const [deleteProposalRecipient, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteProposalRecipient",
    },
    {
      successMessage: getLocalString("proposals.delete-proposal-recipient-success"),
      failureMessage: getLocalString("proposals.delete-proposal-recipient-failure"),
    }
  );

  return [deleteProposalRecipient, context] as const;
}
